<template>
    <blank-layout>


        <div class="-mt-6 flex flex-grow flex-col">

            <div class="flex flex-col md:flex-row w-full flex-grow">



                <div class="flex flex-grow bg-white flex-col justify-center items-center">


                    <div class="flex flex-col w-full max-w-xl">


                        <div>
                            <h3 class="text-blue-500 flex flex-row justify-center items-center gap-x-5">
                                <img src="/img/logo-black-website.svg" width="190" alt="Logo" class="" />
                                <span class="text-birdie-dark font-bold text-4xl mt-1 uppercase">+</span> 
                                <img src="/img/freshchat-logo.svg" width="200" alt="Logo" class="" />
                            </h3>
                        </div>
                        <h1 v-if="status == 'error'"
                            class="text-center text-2xl mt-3 text-gray-700">Houston we have a problem…</h1>
                        <h1 v-else
                        class="text-center text-2xl mt-3 text-gray-700">Congratulations!</h1>

                        <p>&nbsp;</p>

                        <div v-if="status == 'error'"
                            class="mt-10 rounded-md bg-indigo-100 p-6">
                            <p class="">We are sorry but it looks like we encountered an error when connecting {{ app_name }} to Freshdesk Messaging. You can go back to Freshdesk and try to reinstall <vue-feather type="rotate-cw" class="w-4 h-4 mx-2 mt-1"></vue-feather> {{ app_name }}, with an Administrator Account.</p>
                            <p class="mt-6">If the problem persists you can take a look at <a href="https://www.notion.so/hellozest/Birdie-for-Freshchat-Quickstart-233a5805c67b4e96a7f7ad1bf4294f81" title="Help Center" class="text-blue-800 hover:underline">our Help Center</a>, or <a :href="'mailto:support@'+domain+'?subject=Problem%20connecting%20Freshchat%20to%20'+app_name" title="email support" class="text-blue-800 hover:underline">drop us an email</a>.</p>
                        </div>
                        <div v-else
                            class="mt-10 rounded-md bg-indigo-100 p-6">
                            <p class="text-center">Please refresh your Freshchat browser tab to start using {{ app_name }}.</p>
                        </div>

                        <div class="mt-10 flex flex-row justify-center items-center">
                            <a href="/" class="text-center text-gray-400 hover:underline text-sm flex flex-row justify-center items-center gap-x-2">
                                <span>Birdie dashboard</span> <ArrowRightIcon class="w-3 h-3"/></a>
                        </div>


                    </div>


                </div>


            </div>


        </div>

    </blank-layout>
</template>

<script>

    import BlankLayout from "@/Layouts/BlankLayout"
    import { ArrowRightIcon } from '@heroicons/vue/20/solid'

    export default {
        props: [
            'status', // success, error
        ],


        components: {
            BlankLayout, ArrowRightIcon

        },

        data() {
            return {
                domain: this.$page.props.app_url.split('.').slice(-2).join('.'),
                app_name: this.$page.props.app_name
            }
        },

        created() {

        },
        beforeUnmount() {

        },
        mounted() {

        },
        computed: {

        },
        methods: {

        }
    }
</script>


